// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"ErrorWrapper_noScrolling__MHfPV","error":"ErrorWrapper_error__0D5Am","message":"ErrorWrapper_message__X5AZE","action":"ErrorWrapper_action__WfSC2"};